// extracted by mini-css-extract-plugin
export default {"selection-warning":"selection-warning--AQLWTTWXY_","selectionWarning":"selection-warning--AQLWTTWXY_"};